const ConfirmDeletePopup = ({
  user,
  onConfirm,
  onCancel,
  content = "Are you sure you want to delete",
}) => {
  if (!user) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-[90%] max-w-sm">
        <h2 className="text-lg font-semibold mb-4">
          Are you sure you want to delete{" "}
          <span className="text-red-600">{user.fullName}</span>?
        </h2>
        <div className="flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 bg-gray-300 rounded">
            Cancel
          </button>
          <button
            onClick={() => onConfirm(user.id)}
            className="px-4 py-2 bg-red-600 text-white rounded"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeletePopup;
